/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCategoryOverviewGet } from '../fn/category/api-category-overview-get';
import { ApiCategoryOverviewGet$Params } from '../fn/category/api-category-overview-get';
import { apiCategorySyncPost } from '../fn/category/api-category-sync-post';
import { ApiCategorySyncPost$Params } from '../fn/category/api-category-sync-post';
import { CategoryOverviewList } from '../models/category-overview-list';


/**
 * Category service
 */
@Injectable({ providedIn: 'root' })
export class CategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCategoryOverviewGet()` */
  static readonly ApiCategoryOverviewGetPath = '/api/category/overview';

  /**
   * Get category overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCategoryOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCategoryOverviewGet$Response(params?: ApiCategoryOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryOverviewList>> {
    return apiCategoryOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get category overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCategoryOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCategoryOverviewGet(params?: ApiCategoryOverviewGet$Params, context?: HttpContext): Observable<CategoryOverviewList> {
    return this.apiCategoryOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryOverviewList>): CategoryOverviewList => r.body)
    );
  }

  /** Path part for operation `apiCategorySyncPost()` */
  static readonly ApiCategorySyncPostPath = '/api/category/sync';

  /**
   * Upsert a/some category/s.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCategorySyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiCategorySyncPost$Response(params: ApiCategorySyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiCategorySyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a/some category/s.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCategorySyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiCategorySyncPost(params: ApiCategorySyncPost$Params, context?: HttpContext): Observable<void> {
    return this.apiCategorySyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
